import {forwardRef, useState} from 'react'
import {getAvatarUrl} from '../AssetHelpers'

export interface UserAvatarProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  name: string
  avatar?: string | null
  /** Classe do wrapper (ex: symbol-35px, symbol-50px). Default: symbol-35px */
  sizeClass?: string
  /** Incluir symbol-circle no wrapper. Default: true */
  circle?: boolean
  /** Classes adicionais no wrapper */
  className?: string
  /** Classes na img (ex: object-fit-cover, w-100) */
  imgClassName?: string
  /** Classes no span da inicial (ex: symbol-size-md, me-2) */
  symbolLabelClass?: string
}

/**
 * Avatar de usuário com fallback: se não houver avatar ou a imagem falhar (ex: 404 S3),
 * exibe círculo com a inicial do nome.
 * Repassa ref e props de DOM (ex.: onMouseOver do OverlayTrigger) para o wrapper.
 */
const UserAvatar = forwardRef<HTMLDivElement, UserAvatarProps>(function UserAvatar(
  {
    name,
    avatar,
    sizeClass = 'symbol-35px',
    circle = true,
    className = '',
    imgClassName = 'object-fit-cover',
    symbolLabelClass = '',
    style,
    ...rest
  },
  ref
) {
  const [imgFailed, setImgFailed] = useState(false)
  const showImg = avatar && avatar !== 'null' && avatar.trim() && !imgFailed
  const initial = (name || '?').trim().substring(0, 1).toUpperCase()

  return (
    <div
      ref={ref}
      {...rest}
      className={`symbol ${sizeClass} ${circle ? 'symbol-circle' : ''} overflow-hidden ${className}`.trim()}
      style={style}
    >
      {showImg ? (
        <img
          src={getAvatarUrl(avatar)}
          alt={name || ''}
          className={imgClassName}
          onError={() => setImgFailed(true)}
          style={{ objectFit: 'cover' }}
        />
      ) : (
        <span
          className={`symbol-label tr-avatar-fallback fw-bolder d-flex align-items-center justify-content-center ${symbolLabelClass}`.trim()}
        >
          {initial}
        </span>
      )}
    </div>
  )
})

export {UserAvatar}
